export const OPERATION_STATUS_COLORS = {
	"#757575": "bg-[#757575]",
	"#9d50dd": "bg-[#9d50dd]",
	"#216edf": "bg-[#216edf]",
	"#fdab3d": "bg-[#fdab3d]",
	"#df2f4a": "bg-[#df2f4a]",
	"#ffcb00": "bg-[#ffcb00]",
	"#00c875": "bg-[#00c875]",
	"#333333": "bg-[#333333]",
	"#ff007f": "bg-[#ff007f]",
	"#037f4c": "bg-[#037f4c]",
	"#ff5ac4": "bg-[#ff5ac4]",
	"#ff6d3b": "bg-[#ff6d3b]",
	"#9cd326": "bg-[#9cd326]",
	"#784bd1": "bg-[#784bd1]",
	"#7e3b8a": "bg-[#7e3b8a]",
	"#007eb5": "bg-[#007eb5]",
};
